import React from "react";
import { svg } from "../../../../../Assets/svg";
import { Modal } from "antd";

import { useNavigate, useParams } from "react-router-dom";
import { RootState, useAppSelector } from "../../../../../store";
import { getDecryptedUserData } from "../../../../../helpers/bycrypt";
import { ROLE } from "../../../../../helpers/utils";

const CustomerOnHoldWarningModal: React.FC<{
  visible: boolean;
  onClose: any;
  customerOnHoldMessage: any;
  isCustomerDetails?: any;
}> = ({
  visible,
  onClose,
  customerOnHoldMessage,
  isCustomerDetails = false,
}) => {
  const navigate = useNavigate();
  const userData = getDecryptedUserData();
  const isAdminSubadmin =
    userData?.role?.key == ROLE.ADMIN || userData?.role?.key == ROLE.SUB_ADMIN;
  return (
    <Modal
      title={
        <div className="text-center fs-4 fw-bolder lh-m">
          Unable to Create Order!
        </div>
      }
      visible={visible}
      onCancel={onClose}
      width={"32.813rem"}
      closeIcon={svg.closeIcon}
      centered
      footer={
        <div className="d-flex justify-content-center gap-4">
          <button
            type="button"
            className="btn btn-lg btn-outline-secondary min-w-130"
            onClick={onClose}
          >
            CLOSE
          </button>
          {isAdminSubadmin && !isCustomerDetails ? (
            <button
              type="button"
              className="btn btn-lg btn-primary min-w-130"
              onClick={() => {
                navigate(
                  `/clients-distributors/${customerOnHoldMessage?.data?.customer_id}`,
                );
              }}
            >
              VIEW CUSTOMER
            </button>
          ) : (
            ""
          )}
        </div>
      }
      className="custom-modal"
    >
      <p className="fs-6 d-flex justify-content-center mt-3 text-center text-4a4a4a">
        {customerOnHoldMessage?.message ? customerOnHoldMessage?.message : ""}{" "}
        {isAdminSubadmin
          ? `You need to change the customer's status as "Active" to create an order.`
          : "Please contact the administrator."}
      </p>
    </Modal>
  );
};

export default CustomerOnHoldWarningModal;
